import React from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  CardHeader,
  Container,
  ListGroup,
  FormGroup,
  FormInput,
  ListGroupItem,
  FormTextarea,
} from "shards-react";
import Button from '@material-ui/core/Button';
import { getApiUrl } from './Global';
import MySnackbarContentWrapper from '../components/snackbar/MySnackbarContentWrapper';
import {CopyToClipboard} from 'react-copy-to-clipboard';

class EditLpCampaign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInactive: false,
      cpv: '',
      group: '',
      lp_name: '',
      LandingUrl: '',
      landingWeight: '',
      offer: '',
      commission: '',
      offerUrl: '',
      offerWeight: '',
      lpList: [],
      offerList: [],
      platform: {},
    };
    this.offerWeightSum = 0;
    this.landingWeightSum = 0;

    this.switchShowInactive = this.switchShowInactive.bind(this);
    this.handleCPV = this.handleCPV.bind(this);
    this.handleGroup = this.handleGroup.bind(this);
    this.handleLPName = this.handleLPName.bind(this);
    this.handleLandingUrl = this.handleLandingUrl.bind(this);
    this.handlelandingWeight = this.handlelandingWeight.bind(this);
    this.handleOffer = this.handleOffer.bind(this);
    this.handleCommission = this.handleCommission.bind(this);
    this.handleOfferUrl = this.handleOfferUrl.bind(this);
    this.handleOfferWeight = this.handleOfferWeight.bind(this);
    this.handleChangeLPListName = this.handleChangeLPListName.bind(this);
    this.handleChangeLPListUrl = this.handleChangeLPListUrl.bind(this);
    this.handleChangeLPListWeight = this.handleChangeLPListWeight.bind(this);
    this.handleChangeOfferListCommission = this.handleChangeOfferListCommission.bind(this);
    this.handleChangeOfferListName = this.handleChangeOfferListName.bind(this);
    this.handleChangeOfferListUrl = this.handleChangeOfferListUrl.bind(this);
    this.handleChangeOfferListWeight = this.handleChangeOfferListWeight.bind(this);
    this.goLPReport = this.goLPReport.bind(this);
    this.settingsSave = this.settingsSave.bind(this);
    this.landingPageCreate = this.landingPageCreate.bind(this);
    this.offerCreate = this.offerCreate.bind(this);
    this.getData = this.getData.bind(this);
    this.onSaveLPItem = this.onSaveLPItem.bind(this);
    this.onSwitchLPItem = this.onSwitchLPItem.bind(this);
    this.onDeleteLPItem = this.onDeleteLPItem.bind(this);
    this.showAllLPItems = this.showAllLPItems.bind(this);
    this.hideAllLPItems = this.hideAllLPItems.bind(this);
    this.showAllOfferItems = this.showAllOfferItems.bind(this);
    this.hideAllOfferItems = this.hideAllOfferItems.bind(this);
    this.onSaveOfferItem = this.onSaveOfferItem.bind(this);
    this.onSwitchOfferItem = this.onSwitchOfferItem.bind(this);
    this.onDeleteOfferItem = this.onDeleteOfferItem.bind(this);
    this.splitLPItems = this.splitLPItems.bind(this);
    this.splitOfferItems = this.splitOfferItems.bind(this);
    this.onTestLink = this.onTestLink.bind(this);
  }

  componentDidMount() {
    if(!localStorage.getItem("ppvd_token")) {
      alert("You can access this page now.");
      this.props.history.push("login");
    }
    else
      this.getData();
    if(localStorage.getItem("ppvd_lp_campaign_show_all") === "true")
      this.setState({
        showInactive: true,
      });
  }

  onTestLink() {
    window.open(getApiUrl() + 'link?file=' + this.props.match.params.file + '&sub1=' + this.state.platform.sub1 + '&sub2=' + this.state.platform.sub2 + '&sub3=' + this.state.platform.sub3 + '&sub4=' + this.state.platform.sub4 + '&sub5=' + this.state.platform.sub5);
  }

  splitLPItems() {
    var avWeight = this.landingWeightSum / this.state.lpList.length;
    fetch(getApiUrl() + 'split_lp_items', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
        'weight': avWeight,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {

        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  splitOfferItems() {
    var avWeight = this.offerWeightSum / this.state.offerList.length;
    fetch(getApiUrl() + 'split_offer_items', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
        'weight': avWeight,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {

        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showAllLPItems() {
    fetch(getApiUrl() + 'show_all_lp_items', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          var temp = this.state.lpList;
          for (var i = 0; i < temp.length; i++)
            temp[i].hidden = 0;
          this.setState({
            lpList: temp
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  hideAllLPItems() {
    fetch(getApiUrl() + 'hide_all_lp_items', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          var temp = this.state.lpList;
          for (var i = 0; i < temp.length; i++)
            temp[i].hidden = 1;
          this.setState({
            lpList: temp
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showAllOfferItems() {
    fetch(getApiUrl() + 'show_all_offer_items', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          var temp = this.state.offerList;
          for (var i = 0; i < temp.length; i++)
            temp[i].hidden = 0;
          this.setState({
            offerList: temp
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  hideAllOfferItems() {
    fetch(getApiUrl() + 'hide_all_offer_items', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          var temp = this.state.offerList;
          for (var i = 0; i < temp.length; i++)
            temp[i].hidden = 1;
          this.setState({
            offerList: temp
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getData() {
    fetch(getApiUrl() + 'get_campaign_settings', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          this.setState({
            lpList: json.settings,
            offerList: json.offer_settings,
            platform: json.platform,
          })
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  settingsSave() {
    if (!this.state.cpv || isNaN(this.state.cpv) === true) {
      alert("Please input CPV correctly");
      return;
    }
    if (!this.state.group) {
      alert("Please input group name correctly.");
      return;
    }
    fetch(getApiUrl() + 'save_campaign_setting', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
        'cpc': this.state.cpv,
        'group': this.state.group,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          alert("Success");
          this.getData();
        }
        else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  landingPageCreate() {
    if (!this.state.lp_name) {
      alert("Please input LP name correctly.");
      return;
    }
    if (!this.state.LandingUrl) {
      alert("Please input Laning Page URL correctly.");
      return;
    }
    if (!this.state.landingWeight || isNaN(this.state.landingWeight) === true) {
      alert("Please input Landing page weight correctly");
      return;
    }
    fetch(getApiUrl() + 'add_landing_page', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
        'title': this.state.lp_name,
        'weight': this.state.landingWeight,
        'url': this.state.LandingUrl,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          alert("Success");
          this.getData();
        }
        else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  offerCreate() {
    if (!this.state.offer) {
      alert("Please input Offer name correctly.");
      return;
    }
    if (!this.state.commission || isNaN(this.state.commission) === true) {
      alert("Please input offer commission correctly");
      return;
    }
    if (!this.state.offerUrl) {
      alert("Please input Offer URL correctly.");
      return;
    }
    if (!this.state.offerWeight || isNaN(this.state.offerWeight) === true) {
      alert("Please input Offer weight correctly");
      return;
    }
    fetch(getApiUrl() + 'add_offer_url', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
        'title': this.state.offer,
        'weight': this.state.offerWeight,
        'url': this.state.offerUrl,
        'commission': this.state.commission,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          alert("Success");
          this.getData();
        }
        else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onSaveLPItem(index) {
    fetch(getApiUrl() + 'save_lp_item', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
        'title': this.state.lpList[index].title,
        'weight': this.state.lpList[index].weight,
        'url': this.state.lpList[index].url,
        'id': this.state.lpList[index].id,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          alert("Success");
        }
        else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onSwitchLPItem(index) {
    fetch(getApiUrl() + 'hide_lp_item', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
        'hidden': (this.state.lpList[index].hidden * 1) === 1 ? 0 : 1,
        'id': this.state.lpList[index].id,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          var temp = this.state.lpList;
          temp[index].hidden = (temp[index].hidden * 1) === 1 ? 0 : 1;
          this.setState({
            lpList: temp
          });
        }
        else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onDeleteLPItem(index) {
    if(window.confirm("Are you want to delete this data?") === true) {
      fetch(getApiUrl() + 'delete_lp_item', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'token': localStorage.getItem("ppvd_token"),
        },
        body: JSON.stringify({
          'file': this.props.match.params.file,
          'id': this.state.lpList[index].id,
        })
      })
        .then(response => response.json())
        .then(json => {
          if ('success' in json && json.success) {
            var temp = this.state.lpList;
            temp.splice(index, 1);
            this.setState({
              lpList: temp
            });
          }
          else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  onSaveOfferItem(index) {
    fetch(getApiUrl() + 'save_offer_item', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
        'title': this.state.offerList[index].title,
        'weight': this.state.offerList[index].weight,
        'url': this.state.offerList[index].url,
        'id': this.state.offerList[index].id,
        'commission': this.state.offerList[index].commission,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          alert("Success");
        }
        else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onSwitchOfferItem(index) {
    fetch(getApiUrl() + 'hide_offer_item', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': localStorage.getItem("ppvd_token"),
      },
      body: JSON.stringify({
        'file': this.props.match.params.file,
        'hidden': (this.state.offerList[index].hidden * 1) === 1 ? 0 : 1,
        'id': this.state.offerList[index].id,
      })
    })
      .then(response => response.json())
      .then(json => {
        if ('success' in json && json.success) {
          var temp = this.state.offerList;
          temp[index].hidden = (temp[index].hidden * 1) === 1 ? 0 : 1;
          this.setState({
            offerList: temp
          });
        }
        else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onDeleteOfferItem(index) {
    if(window.confirm("Are you want to delete this data?") === true) {
      fetch(getApiUrl() + 'delete_offer_item', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'token': localStorage.getItem("ppvd_token"),
        },
        body: JSON.stringify({
          'file': this.props.match.params.file,
          'id': this.state.offerList[index].id,
        })
      })
        .then(response => response.json())
        .then(json => {
          if ('success' in json && json.success) {
            var temp = this.state.offerList;
            temp.splice(index, 1);
            this.setState({
              offerList: temp
            });
          }
          else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  goLPReport() {
    this.props.history.push('/lpreport/' + this.props.match.params.file);
  }

  handleChangeOfferListCommission(index, event) {
    var temp = this.state.offerList;
    temp[index].commission = event.target.value;
    this.setState({
      offerList: temp
    });
  }

  handleChangeOfferListName(index, event) {
    var temp = this.state.offerList;
    temp[index].title = event.target.value;
    this.setState({
      offerList: temp
    });
  }

  handleChangeOfferListUrl(index, event) {
    var temp = this.state.offerList;
    temp[index].url = event.target.value;
    this.setState({
      offerList: temp
    });
  }

  handleChangeOfferListWeight(index, event) {
    var temp = this.state.offerList;
    temp[index].weight = (event.target.value * 1);
    this.setState({
      offerList: temp
    });
  }

  handleChangeLPListName(index, event) {
    var temp = this.state.lpList;
    temp[index].title = event.target.value;
    this.setState({
      lpList: temp
    });
  }

  handleChangeLPListUrl(index, event) {
    var temp = this.state.lpList;
    temp[index].url = event.target.value;
    this.setState({
      lpList: temp
    });
  }

  handleChangeLPListWeight(index, event) {
    var temp = this.state.lpList;
    temp[index].weight = (event.target.value * 1);
    this.setState({
      lpList: temp
    });
  }

  switchShowInactive() {
    this.setState({
      showInactive: !this.state.showInactive,
    })
    localStorage.setItem("ppvd_lp_campaign_show_all", !this.state.showInactive);
  }

  handleCPV(event) {
    this.setState({
      cpv: event.target.value,
    })
  }

  handleGroup(event) {
    this.setState({
      group: event.target.value,
    })
  }

  handleLPName(event) {
    this.setState({
      lp_name: event.target.value,
    })
  }

  handleLandingUrl(event) {
    this.setState({
      LandingUrl: event.target.value,
    })
  }

  handlelandingWeight(event) {
    this.setState({
      landingWeight: event.target.value,
    })
  }

  handleOffer(event) {
    this.setState({
      offer: event.target.value,
    })
  }

  handleCommission(event) {
    this.setState({
      commission: event.target.value,
    })
  }

  handleOfferUrl(event) {
    this.setState({
      offerUrl: event.target.value,
    })
  }

  handleOfferWeight(event) {
    this.setState({
      offerWeight: event.target.value,
    })
  }

  render() {
    var lpListItems = [];
    var offerListItems = [];
    var lpList = this.state.lpList;
    var offerList = this.state.offerList;
    this.landingWeightSum = 0;
    this.offerWeightSum = 0;
    for (var index = 0; index < lpList.length; index++) {
      var item = lpList[index];
      if ((item.hidden * 1) === 0 || (this.state.showInactive && (item.hidden * 1) === 1)) {
        if((item.hidden * 1) === 0)
          this.landingWeightSum += item.weight;
        lpListItems.push(
          <ListGroup flush className="custom-block-border" key={index}>
            <ListGroupItem className="p-3">
              <Row>
                <Col md={8}>
                  <FormGroup>
                    <Row form>
                      <label className="col-md-2 col-form-label label-responsive">LP Name:</label>
                      <Col md={10}>
                        <FormInput onChange={this.handleChangeLPListName.bind(null, index)} value={item.title} />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Row form>
                      <label className="col-md-2 col-form-label label-responsive">URL:</label>
                      <Col md={10}>
                        <FormInput onChange={this.handleChangeLPListUrl.bind(null, index)} value={item.url} />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Row form>
                      <label className="col-md-2 col-form-label label-responsive">Weight(%):</label>
                      <Col md={10}>
                        <FormInput onChange={this.handleChangeLPListWeight.bind(null, index)} value={item.weight} />
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <Row>
                    <Col className="text-center">
                      <span>Actions</span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col className="text-center">
                      <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.onSaveLPItem.bind(null, index)}>SAVE</Button>
                      <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.onSwitchLPItem.bind(null, index)}>{(item.hidden * 1) === 0 ? 'HIDE' : 'SHOW'}</Button>
                      <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.onDeleteLPItem.bind(null, index)}>DELETE</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </ListGroupItem>
          </ListGroup>
        );
      }
    }
    for (index = 0; index < offerList.length; index++) {
      item = offerList[index];
      if ((item.hidden * 1) === 0 || (this.state.showInactive && (item.hidden * 1) === 1)) {
        if((item.hidden * 1) === 0)
          this.offerWeightSum += item.weight;
        offerListItems.push(
          <ListGroup flush className="custom-block-border" key={index}>
            <ListGroupItem className="p-3">
              <Row>
                <Col md={8}>
                  <FormGroup>
                    <Row form>
                      <label className="col-md-2 col-form-label label-responsive">Offer:</label>
                      <Col md={10}>
                        <FormInput onChange={this.handleChangeOfferListName.bind(null, index)} value={item.title} />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Row form>
                      <label className="col-md-2 col-form-label label-responsive">URL:</label>
                      <Col md={10}>
                        <FormInput onChange={this.handleChangeOfferListUrl.bind(null, index)} value={item.url} />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Row form>
                      <label className="col-md-2 col-form-label label-responsive">Commission($):</label>
                      <Col md={10}>
                        <FormInput onChange={this.handleChangeOfferListCommission.bind(null, index)} value={item.commission} />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Row form>
                      <label className="col-md-2 col-form-label label-responsive">Weight(%):</label>
                      <Col md={10}>
                        <FormInput onChange={this.handleChangeOfferListWeight.bind(null, index)} value={item.weight} />
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <Row>
                    <Col className="text-center">
                      <span>Actions</span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col className="text-center">
                      <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.onSaveOfferItem.bind(null, index)}>SAVE</Button>
                      <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.onSwitchOfferItem.bind(null, index)}>{(item.hidden * 1) === 0 ? 'HIDE' : 'SHOW'}</Button>
                      <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.onDeleteOfferItem.bind(null, index)}>DELETE</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </ListGroupItem>
          </ListGroup>
        )
      }
    }
    return (
      <Container fluid className="main-content-container p-4">
        <Row className="justify-content-center">
          <Col>
            <Card small>
              <CardHeader className="border-bottom">
                <h6 className="m-0">Navigation</h6>
              </CardHeader>
              <CardBody className="p-2 text-center">
                <Button variant="contained" color="primary" className="save-button m-1" onClick={this.switchShowInactive}>{this.state.showInactive ? 'Hide Inactive' : 'Show All'}</Button>
                <Button variant="contained" color="primary" className="save-button m-1" onClick={this.goLPReport}>Campaign Report</Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-center mt-3">
          <Col md={4}>
            <Card small>
              <CardHeader className="border-bottom">
                <h6 className="m-0"> {this.props.match.params.file} Settings</h6>
              </CardHeader>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-12 col-form-label">CPV :</label>
                          <Col>
                            <FormInput onChange={this.handleCPV} />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row form>
                          <label className="col-12 col-form-label">Group :</label>
                          <Col>
                            <FormInput onChange={this.handleGroup} />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row>
                          <Col className="text-right">
                            <Button variant="contained" color="primary" className="save-button" onClick={this.settingsSave}>Save</Button>
                          </Col>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </Card>
          </Col>
          <Col md={4} >
            <Card small>
              <CardHeader className="border-bottom">
                <h6 className="m-0">Add Landing Page</h6>
              </CardHeader>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-12 col-form-label">LP Name:</label>
                          <Col>
                            <FormInput onChange={this.handleLPName} />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row form>
                          <label className="col-12 col-form-label">URL:</label>
                          <Col>
                            <FormInput onChange={this.handleLandingUrl} />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row form>
                          <label className="col-12 col-form-label">Weight  %:</label>
                          <Col>
                            <FormInput onChange={this.handlelandingWeight} />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row>
                          <Col className="text-right">
                            <Button variant="contained" color="primary" className="save-button" onClick={this.landingPageCreate}>Create</Button>
                          </Col>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </Card>
          </Col>
          <Col md={4} >
            <Card small>
              <CardHeader className="border-bottom">
                <h6 className="m-0">Add Offer Url</h6>
              </CardHeader>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-12 col-form-label">Offer Name:</label>
                          <Col>
                            <FormInput onChange={this.handleOffer} />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row form>
                          <label className="col-12 col-form-label">Commission $:</label>
                          <Col>
                            <FormInput onChange={this.handleCommission} />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row form>
                          <label className="col-12 col-form-label">URL:</label>
                          <Col>
                            <FormInput onChange={this.handleOfferUrl} />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row form>
                          <label className="col-12 col-form-label">Weight  %:</label>
                          <Col>
                            <FormInput onChange={this.handleOfferWeight} />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row>
                          <Col className="text-right">
                            <Button variant="contained" color="primary" className="save-button" onClick={this.offerCreate}>Create</Button>
                          </Col>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-center mt-3">
          <Col>
            <Card small>
              <CardHeader className="border-bottom">
                <h6 className="m-0">Postback</h6>
              </CardHeader>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  <Row>
                    <Col>
                    <FormGroup>
                        <Row form>
                          <label className="col-md-2 col-form-label label-responsive">Postback URL:</label>
                          <Col md={8}>
                            <FormInput readOnly value={getApiUrl() + 'track_link?file=' + this.props.match.params.file + '&sub1=' + this.state.platform.sub1 + '&sub2=' + this.state.platform.sub2 + '&sub3=' + this.state.platform.sub3 + '&sub4=' + this.state.platform.sub4 + '&sub5=' + this.state.platform.sub5} />
                          </Col>
                          <CopyToClipboard text={getApiUrl() + 'track_link?file=' + this.props.match.params.file + '&sub1=' + this.state.platform.sub1 + '&sub2=' + this.state.platform.sub2 + '&sub3=' + this.state.platform.sub3 + '&sub4=' + this.state.platform.sub4 + '&sub5=' + this.state.platform.sub5}>
                            <Button variant="contained" color="primary" className="copy-button">Copy</Button>
                          </CopyToClipboard>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-md-2 col-form-label label-responsive">{'Add this php code at the top of action what you want to track. NOTE: Only works on .php pages!'}</label>
                          <Col md={8}>
                            <FormTextarea readOnly value={"<?php\nfile_get_contents('" + getApiUrl() + 'track_link?file=' + this.props.match.params.file + '&sub1=' + this.state.platform.sub1 + '&sub2=' + this.state.platform.sub2 + '&sub3=' + this.state.platform.sub3 + '&sub4=' + this.state.platform.sub4 + '&sub5=' + this.state.platform.sub5 +"');\n?>"} className="custom-form-big-textarea" />
                          </Col>
                          <CopyToClipboard text={"<?php\nfile_get_contents('" + getApiUrl() + 'track_link?file=' + this.props.match.params.file + '&sub1=' + this.state.platform.sub1 + '&sub2=' + this.state.platform.sub2 + '&sub3=' + this.state.platform.sub3 + '&sub4=' + this.state.platform.sub4 + '&sub5=' + this.state.platform.sub5 +"');\n?>"}>
                            <Button variant="contained" color="primary" className="copy-button">Copy</Button>
                          </CopyToClipboard>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-center mt-3">
          <Col>
            <Card small>
              <CardHeader className="border-bottom">
                <h6 className="m-0">Javascript Code:</h6>
              </CardHeader>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-md-2 col-form-label label-responsive">{'Add this javscript code at the page what you want to track.'}</label>
                          <Col md={8}>
                            <FormTextarea readOnly value={"<script type='text/javascript'>\nvar xhttp = new XMLHttpRequest();\nxhttp.open('GET', '" + getApiUrl() + 'track_link?file=' + this.props.match.params.file + '&sub1=' + this.state.platform.sub1 + '&sub2=' + this.state.platform.sub2 + '&sub3=' + this.state.platform.sub3 + '&sub4=' + this.state.platform.sub4 + '&sub5=' + this.state.platform.sub5 +"', true);\nxhttp.send();\n</script>"} className="custom-form-big-textarea" />
                          </Col>
                          <CopyToClipboard text={"<script type='text/javascript'>\nvar xhttp = new XMLHttpRequest();\nxhttp.open('GET', '" + getApiUrl() + 'track_link?file=' + this.props.match.params.file + '&sub1=' + this.state.platform.sub1 + '&sub2=' + this.state.platform.sub2 + '&sub3=' + this.state.platform.sub3 + '&sub4=' + this.state.platform.sub4 + '&sub5=' + this.state.platform.sub5 +"', true);\nxhttp.send();\n</script>"}>
                            <Button variant="contained" color="primary" className="copy-button">Copy</Button>
                          </CopyToClipboard>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-center mt-3">
          <Col>
            <Card small>
              <CardHeader className="border-bottom">
                <h6 className="m-0">Image Pixel:</h6>
              </CardHeader>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  {/* <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-md-2 col-form-label label-responsive">Conversion Pixel(PHP):</label>
                          <Col md={8}>
                          <FormInput readOnly value={'<img width="0" height="0" style="visibility:hidden" src="' + getApiUrl() + 'conv?file=<?php echo isset($_GET["file"]) ? trim($_GET["file"]) : ""; ?>&data_id=<?php echo isset($_GET["data_id"]) ? trim($_GET["data_id"]) : ""; ?>" />'} />
                          </Col>
                          <CopyToClipboard text={'<img width="0" height="0" style="visibility:hidden" src="' + getApiUrl() + 'conv?file=<?php echo isset($_GET["file"]) ? trim($_GET["file"]) : ""; ?>&data_id=<?php echo isset($_GET["data_id"]) ? trim($_GET["data_id"]) : ""; ?>" />'}>
                            <Button variant="contained" color="primary" className="copy-button">Copy</Button>
                          </CopyToClipboard>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row> */}
                  <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-md-2 col-form-label label-responsive">Conversion Pixel:</label>
                          <Col md={8}>
                          <FormInput readOnly value={`<img id="conv-pixel" width="0" height="0" style="visibility:hidden" src="` + getApiUrl() + `conv" />`} />
                          </Col>
                          <CopyToClipboard text={`<img id="conv-pixel" width="0" height="0" style="visibility:hidden" src="` + getApiUrl() + `conv" />`}>
                            <Button variant="contained" color="primary" className="copy-button">Copy</Button>
                          </CopyToClipboard>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-center mt-3">
          <Col>
            <Card small>
              <CardHeader className="border-bottom">
                <h6 className="m-0">Tracking & Offer</h6>
              </CardHeader>
              <ListGroup flush>
                <ListGroupItem className="p-3">
                  <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-md-2 col-form-label label-responsive">Tracking URL:</label>
                          <Col md={8}>
                            <FormInput readOnly value={getApiUrl() + 'link?file=' + this.props.match.params.file + '&sub1=' + this.state.platform.sub1 + '&sub2=' + this.state.platform.sub2 + '&sub3=' + this.state.platform.sub3 + '&sub4=' + this.state.platform.sub4 + '&sub5=' + this.state.platform.sub5}/>
                          </Col>
                          <CopyToClipboard text={getApiUrl() + 'link?file=' + this.props.match.params.file + '&sub1=' + this.state.platform.sub1 + '&sub2=' + this.state.platform.sub2 + '&sub3=' + this.state.platform.sub3 + '&sub4=' + this.state.platform.sub4 + '&sub5=' + this.state.platform.sub5}>
                            <Button variant="contained" color="primary" className="copy-button">Copy</Button>
                          </CopyToClipboard>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-md-2 col-form-label label-responsive">{'Add this code at the very top of yourlanding page, before all other code.NOTE: Only works on .php pages!'}</label>
                          <Col md={8}>
                            <FormTextarea readOnly value={"<?php\n$sub1 = urldecode(trim($_GET['sub1']));\n$sub2 = urldecode(trim($_GET['sub2']));\n$sub3 = urldecode(trim($_GET['sub3']));\n$sub4 = urldecode(trim($_GET['sub4']));\n$sub5 = urldecode(trim($_GET['sub5']));\n$lpid = trim($_GET['lpid']);?>"} className="custom-form-big-textarea" />
                          </Col>
                          <CopyToClipboard text={"<?php\n$sub1 = urldecode(trim($_GET['sub1']));\n$sub2 = urldecode(trim($_GET['sub2']));\n$sub3 = urldecode(trim($_GET['sub3']));\n$sub4 = urldecode(trim($_GET['sub4']));\n$sub5 = urldecode(trim($_GET['sub5']));\n$lpid = trim($_GET['lpid']);?>"}>
                            <Button variant="contained" color="primary" className="copy-button">Copy</Button>
                          </CopyToClipboard>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Row form>
                          <label className="col-md-2 col-form-label label-responsive">Offers Link:</label>
                          <Col md={8}>
                            <FormTextarea readOnly value={getApiUrl() + 'offer?file=' + this.props.match.params.file + '&sub1=<?php echo $sub1; ?>&sub2=<?php echo $sub2; ?>&sub3=<?php echo $sub3; ?>&sub4=<?php echo $sub4; ?>&sub5=<?php echo $sub5; ?>&lpid=<?php echo $lpid; ?>'} className="custom-form-textarea" />
                          </Col>
                          <CopyToClipboard text={getApiUrl() + 'offer?file=' + this.props.match.params.file + '&sub1=<?php echo $sub1; ?>&sub2=<?php echo $sub2; ?>&sub3=<?php echo $sub3; ?>&sub4=<?php echo $sub4; ?>&sub5=<?php echo $sub5; ?>&lpid=<?php echo $lpid; ?>'}>
                            <Button variant="contained" color="primary" className="copy-button">Copy</Button>
                          </CopyToClipboard>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center">
                      <Button variant="contained" color="primary" className="copy-button" onClick={this.onTestLink}>TEST LINK</Button>
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-center mt-3">
          <Col>
            <Card small>
              <CardHeader className="border-bottom">
                <Row className="pl-3 mb-4">
                  <Col>
                    {((this.landingWeightSum < 100 || this.landingWeightSum >= 101) && lpListItems.length > 0) &&
                      <MySnackbarContentWrapper
                        variant="error"
                        message="Your url weight percentages must add up to 100% for all landing pages. Landing pages will evenly rotate until the sum is corrected!"
                      />
                    }
                  </Col>
                </Row>
                <Row className="pl-3">
                  <h6 className="m-0">Landing Page List</h6>
                  <Col className="text-right">
                    <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.showAllLPItems}>ACTIVE ALL</Button>
                    <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.hideAllLPItems}>DEACTIVE ALL</Button>
                    <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.splitLPItems}>EVEN SPLIT</Button>
                  </Col>
                </Row>
              </CardHeader>
              {lpListItems}
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-center mt-3">
          <Col>
            <Card small>
              <CardHeader className="border-bottom">
                <Row className="pl-3 mb-4">
                  <Col>
                    {((this.offerWeightSum < 100 || this.offerWeightSum >= 101) && offerListItems.length > 0) &&
                      <MySnackbarContentWrapper
                        variant="error"
                        message="Your url weight percentages must add up to 100% for all landing pages. Landing pages will evenly rotate until the sum is corrected!"
                      />
                    }
                  </Col>
                </Row>
                <Row className="pl-3">
                  <h6 className="m-0">Offer List</h6>
                  <Col className="text-right">
                    <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.showAllOfferItems}>ACTIVE ALL</Button>
                    <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.hideAllOfferItems}>DEACTIVE ALL</Button>
                    <Button variant="contained" color="primary" className="copy-button m-1" onClick={this.splitOfferItems}>EVEN SPLIT</Button>
                  </Col>
                </Row>
              </CardHeader>
              {offerListItems}
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}
export default EditLpCampaign;